export default __webpack_public_path__ + "media/images/user_photos/122-42867b78981121401d040c577c959170.jpg";